import { Button, TextField } from '@mui/material';
import { L } from 'harmony-language';
import React from 'react';
import { CreateDriverProperty, DriverProperty } from '../../../types';

interface EditCreateResourceProps {
    existingResource: DriverProperty | null;
    onSubmit: (driverProperty: DriverProperty | CreateDriverProperty) => void;
}

export const EditCreateDriverProperty = (props: EditCreateResourceProps) => {
    const { existingResource, onSubmit } = props;

    const [driverProperty, setDriverProperty] = React.useState<DriverProperty | CreateDriverProperty>(existingResource || { name: '' });

    async function submitForm(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        e.stopPropagation();

        onSubmit(driverProperty);
    }

    return (
        <div style={{ minWidth: '20vw' }}>
            <form id='edit-create-driver-property-form' name='edit-create-driver-property-form' onSubmit={submitForm}>
                <TextField
                    label={L.name()}
                    variant='standard'
                    value={driverProperty.name}
                    onChange={(e) => setDriverProperty(locationGroup => ({ ...locationGroup, name: e.target.value }))}
                    fullWidth
                    required
                >
                </TextField>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
                    <Button type='submit' variant='contained' color='primary'>
                        {existingResource ? L.updateDriverProperty() : L.createDriverProperty()}
                    </Button>
                </div>
            </form>
        </div>
    )
}